import { render, staticRenderFns } from "./EntradaTrasladoNewTable.vue?vue&type=template&id=275384c6&"
import script from "./EntradaTrasladoNewTable.vue?vue&type=script&lang=js&"
export * from "./EntradaTrasladoNewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports